import { useNotificationToastQueue } from './hooks/useNotificationToastQueue';
import NotificationToast from './NotificationToast';

export default function NotificationToastQueue() {
	const { currentToast, dismiss } = useNotificationToastQueue();

	if (!currentToast) return null;

	return (
		<div className="fixed right-lg bottom-lg z-200">
			<NotificationToast item={currentToast} onDismiss={dismiss} />
		</div>
	);
}
